'use client';
import React from 'react';
import { useMediaQuery } from 'react-responsive';

const getContrastTextColor = (hexColor: string): string => {
  const color = hexColor.replace('#', '');
  // convert hex to RGB
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 128 ? '#000000' : '#FFFFFF';
};
const hexToRgba = (hex: string, alpha: number): string => {
  const color = hex.replace('#', '');

  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const CustomColorBadge: React.FC<{
  name: string;
  color: string;
  className?: string;
  colorText?: string;
}> = ({ name, color, className = '', colorText }) => {
  const textColor = getContrastTextColor(color);
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  const gradientStyle = {
    background: `linear-gradient(60deg, 
      ${hexToRgba(color, 1)} 0%, 
      ${hexToRgba(color, 0.2)} 50%, 
      ${hexToRgba(color, 1)} 100%)`,
    color: textColor,
  };

  return (
    <div
      className={`h-8 rounded-full inline-flex justify-center items-center gap-1 ${className} ${
        isDesktop ? 'text-sm px-3' : 'text-xs px-2'
      }`}
      style={gradientStyle}
    >
      <div className='text-center justify-start font-bold leading-tight' style={colorText ? { color: colorText } : {}}>
        {name}
      </div>
    </div>
  );
};

const MemberRankBadge: React.FC<{ name: string; color?: string; className?: string; colorText?: string }> = ({
  name,
  className = '',
  color = '',
  colorText = '',
}) => {
  if (color) {
    return <CustomColorBadge name={name} color={color} className={className} colorText={colorText} />;
  }
  return <></>;
};

export default MemberRankBadge;
